import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-form';
import { CheckBoxInput, ErrorMessage } from 'v1/components/shared';
import { validate } from 'v1/helpers/validation';

class CheckboxField extends Component {
  handleValidate = value => {
    if (this.props.validate) {
      return validate(value, this.props.validate.split(','));
    }
  };
  render() {
    const { field, validate, onChange, ...rest } = this.props;

    return (
      <Field field={field} validate={this.handleValidate}>
        {fieldApi => (
          <>
            <CheckBoxInput
              field={field}
              defaultValue={fieldApi.value}
              value={fieldApi.value || false}
              onChange={(name, value) => {
                fieldApi.setValue(value);
                if (onChange) onChange(field, value);
              }}
              error={fieldApi.error}
              {...rest}
            />
            {fieldApi.error && <ErrorMessage>{fieldApi.error}</ErrorMessage>}
          </>
        )}
      </Field>
    );
  }
}

// NOTE: wrapper for CheckBoxInput
CheckboxField.propTypes = {
  field: PropTypes.string,
  validate: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func // TODO: arguments
  // ...rest are from CheckBoxInput
};

export default CheckboxField;
